import * as React from "react";
import CircularProgress from '@material-ui/core/CircularProgress';


export class LoadingScreen extends React.Component {

    render() {
        return (
            <div style={{ textAlign: 'center' }}>
                <h2>{this.props.customMessage?this.props.customMessage:"Now Loading..."}</h2>
                <CircularProgress />
            </div>
        );
    }

};
